const sendLogToBackend = async (level, message, meta = {}) => {
    const BaseUrl = process.env.REACT_APP_BASE_URL;
  try {
    await fetch(`${BaseUrl}api/logs`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        level,
        message,
        meta,
        timestamp: new Date().toISOString(),
      }),
    });
  } catch (error) {
    console.error("Failed to send log to backend:", error);
  }
};

export const logger = {
  info: (message, meta) => sendLogToBackend("info", message, meta),
  warn: (message, meta) => sendLogToBackend("warn", message, meta),
  error: (message, meta) => sendLogToBackend("error", message, meta),
};
